
export const history = require("history").createBrowserHistory();



// WEBPACK FOOTER //
// src/history.js